import { render, staticRenderFns } from "./plan-layout-trip-data.vue?vue&type=template&id=5f0f1fef"
import script from "./plan-layout-trip-data.js?vue&type=script&lang=js&external"
export * from "./plan-layout-trip-data.js?vue&type=script&lang=js&external"
import style0 from "./plan-layout-trip-data.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports